async function FreeGiftPopup(formData, data){
    const add_to_cart_clicked_product_id = Number(formData.get('product-id'));
    const AllCMSValue = window.free_gift_eligible_products.cms_products.split(',');
    const has_matched_product = [...AllCMSValue].some(pro=> Number(pro) === add_to_cart_clicked_product_id);

    
    if(has_matched_product){
        const FreeGiftpopupStatus = await verifyFreeGiftPopupStatus(AllCMSValue);
        if(FreeGiftpopupStatus) return;
        // console.log("FreeGiftpopupStatus: ", FreeGiftpopupStatus)

        await openFreeGiftPoup(formData, data);
    }
}

async function openFreeGiftPoup(formData, data){
    const popup = document.querySelector('.free-gift-product-popup-wrapper');
    if(popup){
        popup.classList.add('active-popup');
        const AllCloseIcon = ['.close-btn', '.free_gift_no_thanks'];
        const AllProceedButtons = ['.continue_shopping_btn', '.popup-final_ATC_btn'];
        const allFreeGiftATCButtons = popup.querySelectorAll('.free-gift-add-to-cart');
        const allVariantSelectors = popup.querySelectorAll('.free-gift-variant-select')

        if(allVariantSelectors.length > 0){
            allVariantSelectors.forEach(selector=>{
                selector.addEventListener('change', ()=>{
                    updateSelectedFreeGift(selector);
                })
            })
        }
        return new Promise((resolve) => {
            if(allFreeGiftATCButtons.length > 0){
                allFreeGiftATCButtons.forEach(button=>{
                    button.addEventListener('click', async ()=>{
                        await buttonStyleUpdate(button, allFreeGiftATCButtons);
                    })
                })
            }
            if(AllProceedButtons.length > 0){
                AllProceedButtons.some(element=>{
                    popup.querySelector(`${element}`).addEventListener('click', async ()=>{
                        await addToCartFreeGift(allFreeGiftATCButtons, data);
                        closePopupInline();
                    })
                })
            }       
            const closeIcon = popup.querySelector('.close-btn');
            popup.classList.add('active-popup');
            const closePopupInline = () => {
                closePopup(popup, allFreeGiftATCButtons);
                resolve();
            };
            [...AllCloseIcon].some(ele=>{
                popup.querySelector(`${ele}`).addEventListener('click', closePopupInline);
            })      
        });
    }
}

function updateSelectedFreeGift(selector){
    const currentSelector = selector.options[selector.selectedIndex];
    const closestGiftWrapper = selector.closest('.free-gift-product-box');
    const selectedVariantImg = currentSelector.getAttribute('data-variant-image');
    const selectedVariantName = currentSelector.getAttribute('data-variant-name');
    if(closestGiftWrapper){
        const FreeGiftImgWrapper = closestGiftWrapper.querySelector('.free-gift-product-img');
        const FreeGiftVariantName = closestGiftWrapper.querySelector('.free_gift_variant_name');
        if(FreeGiftImgWrapper){
            FreeGiftImgWrapper.querySelector('img').src = selectedVariantImg;
            FreeGiftImgWrapper.querySelector('img').srcset = selectedVariantImg;
        }
        if(FreeGiftVariantName){
            FreeGiftVariantName.innerText = selectedVariantName;
        }
    }
}

function buttonStyleUpdate(button, allFreeGiftATCButtons){
    button.classList.add('button-selected');
    if(allFreeGiftATCButtons.length > 0){
        allFreeGiftATCButtons.forEach(btn=> btn.disabled = true);
    }
    const closestGiftProduct = button.closest('.free-gift-product-popup-inner');
    if(closestGiftProduct){
        const selected_count = closestGiftProduct.querySelector('.selected_count');
        const selectedButtons = [...allFreeGiftATCButtons].filter(btn=> btn.classList.contains('button-selected'));
        if(selected_count && selectedButtons.length > 0) selected_count.innerText = `${selectedButtons.length}/${(allFreeGiftATCButtons.length - 1)}`;
    }
}

async function addToCartFreeGift(allFreeGiftATCButtons, data){
    const uniqueID = new Date().getTime();
    const selectedButton = Array.from(allFreeGiftATCButtons).find(btn=> btn.classList.contains('button-selected'));
    if(!selectedButton) return;
    const closestGiftProduct = selectedButton.closest('.free-gift-product-box');
    if(closestGiftProduct){
        const selectedVariantPicker = closestGiftProduct.querySelector('.free-gift-variant-select');
        if(selectedVariantPicker){
            const selectedVariantId = Number(selectedVariantPicker.value);
            data.append('items[1][id]', selectedVariantId);
            data.append('items[1][quantity]', 1);
            data.append('items[1][properties][_free_gift_unique_id]', uniqueID);
        }
    }
}

function closePopup(popupWrapper, allFreeGiftATCButtons){
    popupWrapper.classList.remove('active-popup');

    setTimeout(()=>{
        if(allFreeGiftATCButtons.length > 0){
            allFreeGiftATCButtons.forEach(btn=> btn.disabled = false);
            allFreeGiftATCButtons.forEach(btn=> btn.classList.remove('button-selected'));
        }
        
        if(popupWrapper){
            const selected_count = popupWrapper.querySelector('.selected_count');
            const selectedButtons = [...allFreeGiftATCButtons].filter(btn=> btn.classList.contains('button-selected'));
            if(selected_count) selected_count.innerText = `${selectedButtons.length}/${(allFreeGiftATCButtons.length - 1)}`;
        }
    }, 1000)
}

async function verifyFreeGiftPopupStatus(AllCMSValue) {
  const response = await fetch(`${window.Shopify.routes.root}cart.js`);
  const responseData = await response.json();
  const cartItems = responseData.items;
  
//   let alreadyHaveFreeGiftProduct = false;
//   for (const item of cartItems) {
//     if (AllCMSValue.some(id => Number(id) === item.product_id)) {
//       alreadyHaveFreeGiftProduct = true;
//       break;
//     }
//   }

  const alreadyHaveFreeGiftProduct = cartItems.some(item=> item.properties['_free_gift_unique_id']);
  
  return alreadyHaveFreeGiftProduct;
}